import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/notifications';

export const NOTIFICATION_TYPE_BANK_MISMATCH = 'BANK_MISMATCH_PENDING_REVIEW';

const unwrap = (response) => response?.data?.data ?? response?.data ?? {};

const adminNotificationService = {
  listNotifications: async (params = {}) => {
    const response = await apiClient.get(BASE, {
      params: {
        type: NOTIFICATION_TYPE_BANK_MISMATCH,
        status: 'open',
        page: 1,
        limit: 20,
        ...params,
      },
    });
    const data = unwrap(response);
    return {
      notifications: Array.isArray(data.notifications) ? data.notifications : [],
      pagination: data.pagination || { page: 1, limit: 20, total_records: 0, total_pages: 0 },
    };
  },

  getUnreadCount: async () => {
    const { pagination } = await adminNotificationService.listNotifications({
      status: 'open',
      unread_only: true,
      page: 1,
      limit: 1,
    });
    return Number(pagination?.total_records ?? 0);
  },

  markAsRead: async (uuid) => {
    const response = await apiClient.patch(`${BASE}/${uuid}/read`);
    return unwrap(response);
  },

  markAllAsRead: async (type = NOTIFICATION_TYPE_BANK_MISMATCH) => {
    const response = await apiClient.post(`${BASE}/mark-all-read`, { type });
    return unwrap(response);
  },
};

export default adminNotificationService;
